module.exports = __webpack_public_path__ + "img/Blog2.3d449317.png";